import CustomCard from './CustomCard';
import CardBody from './components/CardBody';
import CardFooter from './components/CardFooter';
import CardHeader from './components/CardHeader';
import FeedbackCard from './components/FeedbackCard';
export default CustomCard;
export { CustomCard, CardBody, CardFooter, CardHeader, FeedbackCard };